import { all, fork, call, put, takeLatest } from 'redux-saga/effects'
import { constants } from '../modules/proposalActions'
import * as api from '../api/proposals'

function* getProposalMilestoneTemplate(action) {
  try {
    const payload = yield call(api.getProposalMilestoneTemplate, action.templateId)

    yield put({ type: constants.GET_PROPOSAL_MILESTONE_TEMPLATE.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_PROPOSAL_MILESTONE_TEMPLATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchgetProposalMilestoneTemplate() {
  yield takeLatest(constants.GET_PROPOSAL_MILESTONE_TEMPLATE.ACTION, getProposalMilestoneTemplate)
}

function* getProposalMilestone(action) {
  try {
    const payload = yield call(api.getProposalMilestone, action.proposalId)

    yield put({ type: constants.GET_PROPOSAL_MILESTONE.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_PROPOSAL_MILESTONE.FAILED,
      message: e.message || e
    })
  }
}

function* watchgetProposalMilestone() {
  yield takeLatest(constants.GET_PROPOSAL_MILESTONE.ACTION, getProposalMilestone)
}

export function* rootSaga() {
  yield all([fork(watchgetProposalMilestoneTemplate), fork(watchgetProposalMilestone)])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/proposalSaga.js